import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import { useThemeProps } from '../system';
import splitStyles from '../system/split-styles';
import { useVariant } from '../VariantProvider';
var textPlugin = {
  styleProps: ['italic', 'truncate', 'size', 'underline', 'weight', 'wrap'],
  getStyles: function getStyles(_ref) {
    var align = _ref.align,
        italic = _ref.italic,
        truncate = _ref.truncate,
        size = _ref.size,
        underline = _ref.underline,
        weight = _ref.weight,
        _ref$wrap = _ref.wrap,
        wrap = _ref$wrap === void 0 ? true : _ref$wrap,
        styles = _objectWithoutPropertiesLoose(_ref, ["align", "italic", "truncate", "size", "underline", "weight", "wrap"]);

    if (align) {
      styles.textAlign = align;
    }

    if (italic) {
      styles.fontStyle = 'italic';
    }

    if (truncate) {
      if (styles.display !== 'block' || styles.display !== 'flex') {
        styles.display = 'block';
      }

      styles.overflow = 'hidden';
      styles.textOverflow = 'ellipsis';
    }

    if (truncate || wrap === false) {
      styles.whiteSpace = 'nowrap';
    }

    if (underline) {
      styles.textDecoration = underline;
    }

    if (typeof size !== 'undefined') {
      styles.fontSize = size;
    }

    if (weight) {
      styles.fontWeight = weight;
    }

    return styles;
  }
};
var defaultElement = 'p';
export function Text(_ref2) {
  var as = _ref2.as,
      innerRef = _ref2.innerRef,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "innerRef"]);

  var _useThemeProps = useThemeProps('text', props),
      inline = _useThemeProps.inline,
      restProps = _objectWithoutPropertiesLoose(_useThemeProps, ["inline"]);

  var Element = as || (inline ? 'p' : defaultElement);
  var variant = useVariant();
  return jsx(Element, _extends({
    ref: innerRef
  }, splitStyles(_objectSpread({
    display: inline ? 'inline-block' : 'block',
    lineHeight: '20px',
    shrink: 1,
    plugin: textPlugin,
    variant: variant
  }, restProps))));
}